import { createContext, useContext, useEffect, useState } from "react";

const BorrowerContext = createContext();

export const useBorrower = () => useContext(BorrowerContext);

export const BorrowerProvider = ({ children }) => {
  const [borrower, setBorrower] = useState(() => {
    const stored = localStorage.getItem("borrower");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (borrower) {
      localStorage.setItem("borrower", JSON.stringify(borrower));
    } else {
      localStorage.removeItem("borrower");
    }
  }, [borrower]);

  return (
    <BorrowerContext.Provider value={{ borrower, setBorrower }}>
      {children}
    </BorrowerContext.Provider>
  );
};
